import Litepicker from 'litepicker';
import { zeroPad } from './utilities';

const short_month_names = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

function datePicker(el, opts) {
  let picker;
  let onSelect;
  const visible_date_format = "YYYY-MM-DD";
  const defaults = {
    element: el,
    format: visible_date_format,
    numberOfMonths: 1,
    numberOfColumns: 1,
    singleMode: true,
    scrollToDate: true,
    useResetBtn: true
  };

  // can be called on an encloding element with hidden date field, eg clickable dateMark
  if (el.nodeName !== 'INPUT') {
    const date_field = el.querySelector('input[type="hidden"]');
    const wrapper = el;
    el = date_field;
    if (date_field) {
      wrapper.addEventListener('click', (e) => picker.show());
    }
    onSelect = (date) => {
      // console.log("📆 onSelect", date);
      if (date) {
        const d = date.getDate();
        const m = date.getMonth();
        const y = date.getFullYear();
        wrapper.querySelectorAll('span.dom').forEach((sp) => sp.innerText = zeroPad(d));
        wrapper.querySelectorAll('span.mon').forEach((sp) => sp.innerText = short_month_names[m]);
        wrapper.querySelectorAll('span.year').forEach((sp) => sp.innerText = y);
        date_field.value = [y, zeroPad(m+1), zeroPad(d)].join('-')
      }
    }
  }
  if (!el.value) {
    // serial form shows default date as a placeholders,
    // and should launch picker around that date
    const t = Date.parse(el.placeholder)
    if (!isNaN(t)) {
      defaults.onShow = () => {
        if (picker && !el.value) {
          picker.gotoDate(t);
        }
      }
    }
  }
  if (opts) Object.assign(defaults, opts);

  // console.log("📆 options", defaults);

  picker = new Litepicker(defaults);
  if (onSelect) picker.on('selected', onSelect);
  return picker;
}

export default datePicker;